import { render, staticRenderFns } from "./choosePaymentMethod.vue?vue&type=template&id=4f7c7080&"
import script from "./choosePaymentMethod.vue?vue&type=script&lang=js&"
export * from "./choosePaymentMethod.vue?vue&type=script&lang=js&"
import style0 from "./choosePaymentMethod.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports